import { render, staticRenderFns } from "./StandingsPlayerResultParts.vue?vue&type=template&id=2dc3cb0c&scoped=true"
import script from "./StandingsPlayerResultParts.vue?vue&type=script&lang=ts"
export * from "./StandingsPlayerResultParts.vue?vue&type=script&lang=ts"
import style0 from "./StandingsPlayerResultParts.vue?vue&type=style&index=0&id=2dc3cb0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc3cb0c",
  null
  
)

export default component.exports